import header from "../images/studyAbroad/header.png";
import usa from "../images/studyAbroad/USA.png";
import uk from "../images/studyAbroad/UK.png";
import canada from "../images/studyAbroad/Canada.png";
import australia from "../images/studyAbroad/Australia.png";
import newZealand from "../images/studyAbroad/NewZealand.png";
import eu from "../images/studyAbroad/EuropeanUnion.png";
import freeServices from "../images/studyAbroad/freeServices.png";
import check from "../images/studyAbroad/check.svg";

const StudyAbroad = () => {
  const countryData = [
    { name: "USA", image: usa, flag: "🇺🇸" },
    { name: "UK", image: uk, flag: "🇬🇧" },
    { name: "Canada", image: canada, flag: "🇨🇦" },
    { name: "Australia", image: australia, flag: "🇦🇺" },
    { name: "New Zealand", image: newZealand, flag: "🇳🇿" },
    { name: "European Union", image: eu, flag: "🇪🇺" },
  ];

  return (
    <div className="studyAbroad">
      <div className="header">
        <div className="container">
          <h1>Study Abroad</h1>
          <h2>
            Your Path to <b>Global Education</b> Starts Here
          </h2>
          <p>
            Studying abroad opens doors to global opportunities, personal
            growth, and world-class education. With expert guidance from Gr8
            Appers, you’ll confidently navigate every step — from choosing the
            right university to acing applications, securing scholarships, and
            preparing for life abroad.
          </p>
        </div>
        <img src={header} alt="Study Abroad Header" className="headerImage" />
      </div>
      <div className="countries">
        <div className="container">
          <div className="countriesDesc">
            <h3>
              Countries <b>We Support</b>
            </h3>
            <p>
              Gr8 Appers offers assistance for studying in several top
              destinations, each providing unique benefits to Indian students.
              Here’s a closer look at why these countries are excellent choices
            </p>
            <a href="/contact" className="viewCountries button">
              Apply Today
            </a>
          </div>
        </div>
        <div className="marquee-container">
          <div className="countryList marquee">
            {countryData.map((country, index) => (
              <div className="country" key={index}>
                <img src={country.image} alt={country.name} />
                <p className="mdText">
                  {country.name} {country.flag}
                </p>
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {countryData.map((country, index) => (
              <div className="country" key={`dup-${index}`}>
                <img src={country.image} alt={country.name} />
                <p className="mdText">
                  {country.name} {country.flag}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="freeServices">
        <div className="container">
          <div className="serviceList">
            <ul>
              <h3>
                Our <b>Free Services</b>
              </h3>
              <li>
                <img src={check} alt="check" />{" "}
                <p className="lgText">Expert Guidance and Counseling</p>
              </li>
              <li>
                <img src={check} alt="check" />{" "}
                <p className="lgText">Streamlined Application Process</p>
              </li>
              <li>
                <img src={check} alt="check" />{" "}
                <p className="lgText">Visa Assistance and Support</p>
              </li>
              <li>
                <img src={check} alt="check" />{" "}
                <p className="lgText">
                  Scholarship and Financial Planning Advice
                </p>
              </li>
              <li>
                <img src={check} alt="check" />{" "}
                <p className="lgText">Pre-Departure and Post-Arrival Support</p>
              </li>
            </ul>
            <div className="serviceListImg">
              <img src={freeServices} alt="Free Services" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudyAbroad;
